module.exports = __webpack_public_path__ + "img/sv89.390f8a27.svg";